module.exports = __webpack_public_path__ + "static/img/home_logo_cuc.072e368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_logo_cuc.png
// module id = o6TU
// module chunks = 4